import { render, staticRenderFns } from "./TableListComponent.vue?vue&type=template&id=1ca2b621&scoped=true&"
import script from "./TableListComponent.vue?vue&type=script&lang=js&"
export * from "./TableListComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableListComponent.vue?vue&type=style&index=0&id=1ca2b621&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca2b621",
  null
  
)

export default component.exports